'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ContentContainer = require('./ContentContainer');

var _ContentContainer2 = _interopRequireDefault(_ContentContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ContentContainer2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ContentContainer/index.js
// module id = 567
// module chunks = 11